import React from "react";

import { Box, Popover, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import "./index.scss";

const useStyles = makeStyles(() => ({
  root: {
    "& .MuiPaper-root": {
      boxShadow: "0px 0px 8px #00000033;",
    },
    "& .MuiTypography-body1": {
      color: "var(--color-medium-grey)",
      font: "normal normal normal 9px/1px Noto Sans",
    },
  },
}));

export default function PopoverText(props) {
  const { descriptionText, descriptor, iconPosition } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const classes = useStyles(props);
  
  const onFocusOnHere = (event) => {
    if (event) setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => setAnchorEl(null);

  return (
    <>
      <span
        className="popover-descriptor"
        aria-owns={open ? "mouse-over-popover" : undefined}
        aria-haspopup="true"
        onMouseEnter={onFocusOnHere}
      >
        {descriptor}
      </span>
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: "none",
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
        classes={{ root: classes.root }}
        PaperProps={{
          onMouseLeave: handlePopoverClose,
          style: {
            backgroundColor: "transparent",
            boxShadow: "none",
            borderRadius: 0,
          },
        }}
        onExit={handlePopoverClose}
      >
        <Box
          sx={{
            position: "relative",
            mt: "5px",
            "&::before": {
              backgroundColor: "var(--color-primary)",
              content: '""',
              display: "block",
              position: "absolute",
              width: 8,
              height: 8,
              top: -4,
              transform: "rotate(45deg)",
              left: iconPosition || "8px",
            },
          }}
        />
        <Typography>
          <div className={`popover-description-text  ${props.customClass} `}>
            <span>{descriptionText}</span>
          </div>
        </Typography>
      </Popover>
    </>
  );
}
